'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.minutesSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/minutesSince.js
// module id = 575
// module chunks = 0